<form [formGroup]="formGroup" (ngSubmit)="submit()" class="form-group entry-form" autocomplete="off">
    <box>
        <header *ngIf="_commonService.isMobile()">
              <fpx-button className="back" btnType="button" label="Back" (onClick)="_helper.closePreview()"></fpx-button>
              <fpx-button className="home" btnType="button" label="Home"></fpx-button>
        </header>
        <box class="preview-header">
            <h4>{{_helper.title}}</h4>
            <button class="button-icon" (click)="_helper.closePreview()">
                <span class="icon close"></span>
                <span class="text"></span>
            </button>
        </box>

        <box class="doc-img-preview-wrapper">
            <ng-container *ngFor="let file of state.data.files; let i = index">
                <box class="file">
                    <img class="file-preview" width='100%' height='100%' [src]="_helper.dom.bypassSecurityTrustUrl(file.imageSrc)" alt="document-front-preview"/>
                    <box class="file-details">
                            <span class="file-name" (click)="_helper.downloadFile(i)">{{ file.name }}</span>
                            <box class="file-icons">
                                <button class="download-btn button-icon" (click)="_helper.previewFile(i)">
                                    <span class="icon download"></span>
                                    <span class="text"></span>
                                </button>
                                <!-- <button class="button-icon" *ngIf="_helper.isDeleteRequired()" (click)="_helper.onDelete(i)">
                                    <span class="icon delete"></span>
                                    <span class="text"></span>
                                </button> -->
                                <!-- <img src="./assets/images/icons/download.svg" alt="Preview" />
                                <img src="./assets/images/icons/delete.svg" alt="Delete" /> -->
                            </box>
                    </box>
                </box>
                
            </ng-container>
        </box>
        <footer *ngIf="_commonService.isMobile()" class="form-actions">
            <fpx-button className="secondary" btnType="button" (onClick)="_helper.closePreview()" label="Back"></fpx-button>
        </footer>
    </box>
    
</form>
